import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';
import { billingResolver } from './resolvers/billing.resolver';
import { subscriptionsResolver } from './resolvers/subscriptions.resolver';

export const billingRoutes: Routes = [
  {
    path: 'billing',
    title: 'WEB_BILLING_AAA',
    resolve: {
      userBean: userBeanResolver,
      agorai18n: i18nResolver,
      billing: billingResolver,
      subscriptions: subscriptionsResolver,
    },
    loadComponent: () =>
      import('./pages/billing.component').then((m) => m.BillingComponent),
    data: { navigationRoute: ROUTE_NAMES.BILLING },
    children: [
      {
        path: 'subscribe',
        loadComponent: () =>
          import('./pages/subscription.component').then(
            (m) => m.SubscriptionComponent
          ),
      },
      {
        path: 'review-details',
        loadComponent: () =>
          import('./pages/review-subscription.component').then(
            (m) => m.ReviewSubscriptionComponent
          ),
      },
      {
        path: 'payment-method',
        loadComponent: () =>
          import('./pages/select-payment.component').then(
            (m) => m.SelectPaymentComponent
          ),
      },
      {
        path: 'confirm-subscription',
        loadComponent: () =>
          import('./pages/confirm-subscription.component').then(
            (m) => m.ConfirmSubscriptionComponent
          ),
      },
    ],
  },
];
